import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateService, Events, MessageService } from 'src/app/core/services';
import { ServiceLocations } from 'src/app/shared/api-models/admin';
import { SortConfig } from 'src/app/shared/view-models/sort-config';
import { LocationsService } from '../locations.service';
import { LocationsSortColumns } from './sort-columns.enum';
@Component({
	selector: 'l-locations-table',
	templateUrl: './locations-table.component.html'
})
export class LocationsTableComponent {
	@Input() searchTerm: string;
	@Input() getLocations: () => void;
	sortConfig: SortConfig = {
		column: LocationsSortColumns.NAME,
		direction: 'asc'
	};
	readonly sortColumns = LocationsSortColumns;

	constructor(
		private appStateService: AppStateService,
		public locationsService: LocationsService,
		private messageService: MessageService,
		private router: Router
	) {}

	public onViewClick(location: ServiceLocations): void {
		this.appStateService.setSessionItem('locationId', JSON.stringify(location.Id));
		this.router.navigate([`/crm/client-details/locations/location-details`]);
	}

	public onDeleteClick(location: ServiceLocations): void {
		const confirmDelete: boolean = confirm(`Delete service location "${location.Name}"?`);
		if (confirmDelete) {
			this.messageService.publish(Events.savingPreloader, 1);
			this.locationsService.deleteLocation(location.Id).subscribe(() => {
				this.getLocations();
				this.messageService.publish(Events.savingPreloader, 0);
			});
		}
	}

	public getSortIconClass(column: LocationsSortColumns): string {
		if (this.sortConfig.column !== column) {
			return 'fas fa-sort';
		}
		return this.sortConfig.direction === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
	}

	public onSort(newConfig: SortConfig) {
		this.sortConfig = newConfig;
	}

	public valueAccessor = (item: ServiceLocations, column: LocationsSortColumns) => {
		switch (column) {
			case LocationsSortColumns.NAME:
				return item.Name;
			case LocationsSortColumns.ADDRESS:
				return item.Address1;
			case LocationsSortColumns.CITY:
				return item.City;
			case LocationsSortColumns.STATE:
				return item.State;
			case LocationsSortColumns.PHONE:
				return item.Phone;
			case LocationsSortColumns.HOLD_UNIT:
				return item.holdUnit;
			case LocationsSortColumns.HOLD_COUNT:
				return item.holdCount;
			case LocationsSortColumns.VIDEO_COUNT:
				return item.videoCount;
			case LocationsSortColumns.POSTER_COUNT:
				return item.posterCount;
			case LocationsSortColumns.RADIO_COUNT:
				return item.radioCount;
			case LocationsSortColumns.WEB_COUNT:
				return item.webCount;
			case LocationsSortColumns.VIDEO_WALL_COUNT:
				return item.videoWallCount;
			default:
				return '';
		}
	};
}
